import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CountryExt, CountryExtMap } from 'src/definitions/country.definition';
import { IconModule } from '../icon/icon.module';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { InputTextComponent } from './input-text.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-input-phone-ext',
  templateUrl: './input-phone-ext.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PopoverModule,
    IconModule,
    InputTextComponent,
    ButtonComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPhoneExtComponent),
      multi: true,
    },
  ],
})
export class InputPhoneExtComponent implements ControlValueAccessor {
  @Input()
  disabled: boolean = false;

  @Input()
  autofocus: boolean = false;

  @Input()
  styleClass: string = '';

  @Input()
  boxStyleClass: string = '';

  extSearch: string = '';

  CountryExt = CountryExt;
  CountryExtMap = CountryExtMap;

  set value(value: string | number) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
  }
  get value() {
    return this._value;
  }

  private _value: string | number = '';
  private onChange: (value: string | number) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  writeValue(value: string | number): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  handleSearchExt() {
    this.CountryExt = CountryExt.filter((country) => {
      const searchKeyword = this.extSearch.toLowerCase();
      return [country.code.toLowerCase(), country.country.toLowerCase(), country.ext.toLowerCase()]
        .join(' ')
        .includes(searchKeyword);
    }).sort((a, b) => a.country.localeCompare(b.country));
  }
}
